function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { IconButton, Menu, useOverlayContext } from 'seagull';
import { DocumentCheckmark24, ChevronRight24, Invoice24, Plus, UserAddLiner24 } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import DisabledBillingTooltip from "../../../DisabledBillingTooltip";
import { ManageContactModalForVendor } from "../../../ManageContactModal/ManageContactModalForVendor";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { useGlobalBillClient } from "../../../../hooks/useGlobalBillClient";
import { useOpenNewProposal } from "../../../../hooks/useOpenNewProposal";
import { Intent } from "../../../../infra/access-control";
import { jsx as _jsx } from "react/jsx-runtime";
export let ItemId = /*#__PURE__*/function (ItemId) {
  ItemId["BillClient"] = "bill-client";
  ItemId["CreateContact"] = "create-contact";
  ItemId["CreateProposal"] = "create-proposal";
  return ItemId;
}({});
export const getQuickActionsMenuTID = () => getTestIds();
export function QuickActionsMenu() {
  const {
    QuickActionsMenuTID
  } = useMemo(() => getQuickActionsMenuTID(), []);
  const {
    DISABLE_BILLING_SCAN
  } = useFeatureFlags();
  const {
    openGlobalBillModal
  } = useGlobalBillClient();
  const {
    showModal,
    showBottomSheet,
    hideBottomSheet
  } = useOverlayContext();
  const {
    isLoadingProposalTemplates,
    openNewProposal
  } = useOpenNewProposal();
  function handleClick() {
    const items = [{
      id: ItemId.BillClient,
      body: 'Bill client',
      prefixIcon: /*#__PURE__*/_jsx(Invoice24, {}),
      intent: Intent.AddCharge,
      disabled: DISABLE_BILLING_SCAN,
      tooltip: DISABLE_BILLING_SCAN ? /*#__PURE__*/_jsx(DisabledBillingTooltip, {}) : undefined,
      onClick: () => {
        hideBottomSheet();
        openGlobalBillModal();
      }
    }, {
      id: ItemId.CreateContact,
      body: 'Create contact',
      prefixIcon: /*#__PURE__*/_jsx(UserAddLiner24, {}),
      onClick: () => {
        hideBottomSheet();
        showModal({
          closeOnEscapeKey: true,
          closeOnClickOutside: true,
          content: _ref => {
            let {
              dismissModal
            } = _ref;
            return /*#__PURE__*/_jsx(ManageContactModalForVendor, {
              "data-testid": "manage-contact-modal",
              onClose: dismissModal,
              origin: "Quick actions menu"
            });
          }
        });
      }
    }, {
      id: ItemId.CreateProposal,
      body: 'Create proposal',
      disabled: isLoadingProposalTemplates,
      prefixIcon: /*#__PURE__*/_jsx(DocumentCheckmark24, {}),
      onClick: () => {
        hideBottomSheet();
        openNewProposal();
      }
    }].map(item => _objectSpread(_objectSpread({}, item), {}, {
      testId: QuickActionsMenuTID.Item(item.id),
      suffixIcon: /*#__PURE__*/_jsx(ChevronRight24, {})
    }));
    showBottomSheet({
      content: /*#__PURE__*/_jsx(Menu, {
        dimensions: {
          width: 'auto',
          paddingBottom: 8
        },
        items: items
      })
    });
  }
  return /*#__PURE__*/_jsx(IconButton, {
    skin: "primaryBoxed",
    size: "smallMedium",
    "data-testid": QuickActionsMenuTID.Button(),
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(Plus, {
      height: 16,
      width: 16
    })
  });
}